module.exports = __webpack_public_path__ + "0274129b9b6f754e280ae3b01cf50422.gif";